import axios from "axios";
import Const from "../utils/constant";

const axiosInstance = axios.create({
  baseURL: `${Const.API.BASE_URL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});
export default axiosInstance;
